<template>
  <div class="container">
    <div class="exam">
      <template v-if="PageInfo.data.length > 0">
        <div class="exam-history__list">
          <div
            v-for="(item, index) in PageInfo.data"
            :key="index"
            class="exam-history"
          >
            <h5>
              {{ item.examinationStartDate | toTaipei | moment('YYYY/MM/DD HH:mm:ss') }}
            </h5>

            <div class="exam-history__detail">
              <span>{{ $t('exam.score') }}：{{ item.examTotal }}分</span>
              <span>{{ $t('exam.examTime') }}：{{ item.questionTime }}分鐘</span>
            </div>

            <router-link
              class="exam-history__btn"
              :to="`/practices/examReview/${courseId}/${subjectId}/${item.examinationId}`"
            >
              {{ $t('exam.button.view') }}
            </router-link>
          </div>
        </div>

        <!-- 分頁 -->
        <div class="pagination pagination--center">
          <el-pagination
            background
            layout="total, prev, pager, next, jumper"
            :current-page.sync="Pagination.pageIndex"
            :page-size="Pagination.pageSize"
            :total="PageInfo.count"
            @current-change="GetList()"
          />
        </div>
      </template>

      <div v-else class="exam__empty">
        <i class="el-icon-document-delete"></i>
        <p>{{ $t('exam.message.noExamHistory') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { GetPracticeBreadcrumb } from '@/api/BuyPracticeApi';
import { GetExaminations } from '@/api/MemberExamination';

export default {
  data() {
    // 建立你的初始化 model data
    return {
      courseId: 0,
      subjectId: 0,
      Args: {
        courseId: '',
        subjectId: '',
      },
      Pagination: {
        // 有分頁要有此model data
        pageIndex: 1, // 預設從第幾頁開始
        pageSize: 10, // 預設每頁幾筆
        data: {
          courseId: '',
          subjectId: '',
        },
      },
      PageInfo: {
        count: 0, // api給的總筆數
        data: [],
      },
    };
  },
  // 當有設定keep的時候，返回到此頁面會執行這個，不會執行created()，所以這邊就不用放created()
  async activated() {
    this.courseId = this.$route.params?.id;
    this.subjectId = this.$route.params?.subjectId;

    if (!this.$route.meta.isBack) {
      // 不是從指定頁面返回的話，進行初始化設定
      this.Args = {
        courseId: this.courseId,
        subjectId: this.subjectId,
      };
      this.Pagination = {
        pageIndex: 1, // 預設從第幾頁開始
        pageSize: 10, // 預設每頁幾筆
        data: {
          courseId: this.courseId,
          subjectId: this.subjectId,
        },
      };
      this.PageInfo = {
        count: 0, // api給的總筆數
        data: [],
      };
    }
    // 然後再針對頁面進行初始化資料存取
    this.GetAll();
  },
  methods: {
    GetPracticeBreadcrumb() {
      return new Promise((resolve, reject) => {
        const data = {
          courseId: this.courseId,
          subjectId: this.subjectId,
        };

        GetPracticeBreadcrumb(data)
          .then((response) => {
            if (response.data.statusCode === 0) {
              if (!this._.isEmpty(response.data.data)) {
                this.$emit('update:currentPage', [
                  {
                    name: 'learnings',
                    title: this.$t('route.title.myCourses'),
                    path: '',
                  },
                  {
                    name: 'learning',
                    title: `${response.data.data.courseName}`,
                    path: `/learning/${response.data.data.courseId}`,
                  },
                  {
                    name: 'practices',
                    title: this.$t('route.title.exam'),
                    path: `/practices/${response.data.data.courseId}`,
                  },
                ]);
              }
            }

            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    GetAll() {
      this.courseId = this.$route.params?.id;
      this.subjectId = this.$route.params?.subjectId;

      if (!this.courseId || !this.subjectId) {
        this.$message({
          type: 'error',
          message: this.$t('exam.message.noExamHistory'),
        });

        return;
      }

      this.GetPracticeBreadcrumb()
        .then(() => {
          this.GetList();
        })
        .catch(() => {
          this.$router.replace('/error').catch();
        });
    },
    GetList() {
      this.Args = {
        subjectId: this.subjectId,
        courseId: this.courseId,
      };

      this.Pagination.data = { ...this.Args };

      GetExaminations(this.Pagination)
        .then((response) => {
          if (response.data.statusCode === 0) {
            this.PageInfo.count = response.data.count;
            this.PageInfo.data = response.data.data;

            if (this.Pagination.pageIndex !== 1 && this.PageInfo.data.length === 0) {
              this.Pagination.pageIndex = 1;
              this.GetList();
            }
          }
        })
        .catch(() => {
          this.$router.replace('/error').catch();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/_exam.scss';
</style>
